exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".faqs--greySubHeading--1cpUhYiE {\r\n  font-weight: 600;\r\n  color: #5B6770;\r\n}\r\n\r\n.faqs--blueQuestionTitle--1pabP9tj {\r\n  color: #0072CE;\r\n}\r\n\r\n.faqs--answer--9D2QPU5D p {\r\n  color: #5B6770;\r\n}\r\n\r\n.faqs--catPanel--zcYK-Mnr:hover {\r\n  background-color: #ECECEC;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/help/faqs/faqs.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;CAChB;;AAED;EACE,eAAe;CAChB;;AAED;EACE,eAAe;CAChB;;AAED;EACE,0BAA0B;CAC3B","file":"faqs.css","sourcesContent":[".greySubHeading {\r\n  font-weight: 600;\r\n  color: #5B6770;\r\n}\r\n\r\n.blueQuestionTitle {\r\n  color: #0072CE;\r\n}\r\n\r\n.answer p {\r\n  color: #5B6770;\r\n}\r\n\r\n.catPanel:hover {\r\n  background-color: #ECECEC;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"greySubHeading": "faqs--greySubHeading--1cpUhYiE",
	"blueQuestionTitle": "faqs--blueQuestionTitle--1pabP9tj",
	"answer": "faqs--answer--9D2QPU5D",
	"catPanel": "faqs--catPanel--zcYK-Mnr"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/help/faqs/faqs.css
// module id = 385
// module chunks = 0